import { ROLES } from '@helpers';
import type { OnboardingWizardRole } from '@api/domain/types';

export const TOTAL_STEPS = 4;

// Card sizing (tablet/web). Phone uses edge-to-edge fallback.
export const MODAL_WIDTH = 640;
export const MODAL_MIN_HEIGHT = 570;
export const MODAL_BORDER_RADIUS = 16;

export const OTHER_VALUE = 'Other';
export const OTHER_PREFIX = 'Other: ';

// Step indices in the wizard's local state machine.
// 0 = Welcome, 1..4 = form steps, 5 = Submitted (Thank you).
export const STEP = {
  WELCOME: 0,
  MACHINES: 1,
  ERP: 2,
  GOALS: 3,
  TEAM: 4,
  SUBMITTED: 5,
} as const;

export type StepIndex = (typeof STEP)[keyof typeof STEP];

// Welcome and Submitted share the centered-logo layout (logo pushed down, chrome hidden).
export const isCenteredLogoStep = (step: StepIndex) =>
  step === STEP.WELCOME || step === STEP.SUBMITTED;

// How long the Thank you screen lingers before redirecting to OnHold.
export const SUBMITTED_HOLD_MS = 2500;

export const MIN_MACHINES = 0;
export const MAX_MACHINES = 9999;

export const TRANSITION_DURATION_MS = 300;
export const TRANSITION_OFFSET = 24;

export const WELCOME_TRANSITION_MS = 450;
export const WELCOME_FADE_MS = 300;
export const WELCOME_LOGO_PUSH_PHONE = 200;
export const WELCOME_LOGO_PUSH_MODAL = 110;
// Content's translateY in welcome state. Smaller than the logo's push so welcome content
// lands directly under the logo (gap ≈ 20px) rather than offset further by the chrome's
// reserved layout space (progress + its margin).
export const WELCOME_CONTENT_PUSH_PHONE = 154;
export const WELCOME_CONTENT_PUSH_MODAL = 64;

export const MACHINE_CONTROL_OPTIONS: string[] = [
  'Heidenhain',
  'Siemens',
  'Fanuc',
  'Mazak',
  'Okuma',
  'Mitsubishi',
  OTHER_VALUE,
];

export const ERP_OPTIONS: string[] = [
  'MKG',
  'Bemet',
  'Ridder iQ',
  'ISAH',
  'Epicor',
  'Microsoft Dynamics',
  'SAP',
  'No ERP',
  OTHER_VALUE,
];

export const GOAL_OPTIONS: string[] = [
  'Reduce downtime',
  'Improve OEE',
  'Track production',
  'Reduce setup time',
  'Improve planning',
  'Reporting',
  'Collaboration',
  'Quality control',
  'Reduce waste',
  'Increase capacity',
  'Cost reduction',
  OTHER_VALUE,
];

export const ROLE_OPTIONS: OnboardingWizardRole[] = [ROLES.ADMINISTRATOR, ROLES.MANAGER, ROLES.OPERATOR];
export const DEFAULT_ROLE: OnboardingWizardRole = ROLES.ADMINISTRATOR;
